import { type OidcClient } from './types';

let current: OidcClient | null = null;

/** The OIDC client installed by `AuthProvider` (or `setAuthClient`), if any. */
export function getAuthClient(): OidcClient | null {
  return current;
}

/** Installs (or clears) the process-wide OIDC client used by the default API client. */
export function setAuthClient(client: OidcClient | null): void {
  current = client;
}
